import { Card, Col, Row, Space, Timeline } from 'antd'
import React, { useState } from 'react'

export default function InfoInicio() {
    const [mode] = useState<'left' | 'alternate' | 'right'>('right');
    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Row gutter={10}>
                <Col span={18}>
                    <Card title="Informações:">
                        Seja bem vindo ao FSJus,
                        selecione um item no menu ao lado.
                    </Card>
                </Col>
                <Col span={6}>
                    <Card title="Releases:">
                        <Timeline
                            mode={mode}
                            items={[
                                {
                                    label: '11/13/2023',
                                    children: 'Lançamento, versão 1.0.0.',
                                },
                                {
                                    label: '11/13/2023',
                                    children: 'Produção, versão 1.0.0.',
                                },
                                {
                                    label: '11/13/2023',
                                    children: 'Bug Fix: Download PDF, Estado Civil Select e remoção obrigatoriedade Email e Telefone.',
                                },
                                {
                                    label: '18/11/2023',
                                    children: 'Criação de feature de gerar relatório de clientes.',
                                },
                            ]}
                        />
                    </Card>
                </Col>
            </Row>
        </Space>
    )
}
